import api from './client';

export const fetchOrders = (params: any) =>
  api.get('/orders', { params }).then(res => res.data);

export const syncOrders = () =>
  api.post('/orders/sync').then(res => res.data);

export const markOrdersDeleted = (orderNumbers: string[], reason?: string) =>
  api.post('/orders/mark-deleted', { orderNumbers, reason }).then(res => res.data);

export const restoreOrders = (orderNumbers: string[]) =>
  api.post('/orders/restore', { orderNumbers }).then(res => res.data);

export const validateUniuniOrders = (orders: any[], pickup_address_id: number) =>
  api.post('/uniuni/validate', { orders, pickup_address_id }).then(res => res.data);

export const updateOrderPackageData = (orders: any[]) =>
  api.patch('/orders/package-data', { orders }).then(res => res.data);

export const confirmUniuniShipments = (orders: any[], pickup_address_id: number) =>
  // Batch of N orders sequentially calls UniUni + ShipStation for each. SS's
  // 40 req/min limiter makes this scale linearly with batch size (~5-8s per
  // order). Bump timeout to 5 min so a 20-order batch doesn't false-fail on
  // the client while the backend keeps creating shipments in the background.
  api.post('/uniuni/shipments', { orders, pickup_address_id }, { timeout: 300_000 })
    .then(res => res.data);

// Async batch job flow. POST creates a job and returns { jobId } in ~50ms;
// frontend polls the GET endpoint until status === 'complete'|'failed'.
// This is the timeout-safe path for large batches — should be preferred
// over the sync confirmUniuniShipments.
export const startShipmentBatch = (orders: any[], pickup_address_id: number) =>
  api.post('/uniuni/shipments/batch', { orders, pickup_address_id })
    .then(res => res.data as { jobId: string; total: number });

export const getShipmentBatch = (jobId: string) =>
  api.get(`/uniuni/shipments/batch/${jobId}`).then(res => res.data as {
    id: string;
    status: 'pending' | 'processing' | 'complete' | 'failed';
    total: number;
    succeeded: number;
    failed: number;
    skipped: number;
    per_order_state: Record<string, {
      status: 'pending' | 'success' | 'error' | 'skipped';
      trackingNumber?: string | null;
      uniuniOrderId?: string | null;
      orderSn?: string | null;
      error?: string;
    }>;
    error_message: string | null;
  });

export const retryShipmentBatch = (jobId: string) =>
  api.post(`/uniuni/shipments/batch/${jobId}/retry`).then(res => res.data as { retried: number });

export const listShipmentBatches = () =>
  api.get('/uniuni/shipments/batches').then(res => res.data as {
    jobs: Array<{
      id: string;
      user_id: number | null;
      status: 'pending' | 'processing' | 'complete' | 'failed';
      total: number;
      succeeded: number;
      failed: number;
      skipped: number;
      created_at: string;
      completed_at: string | null;
      error_message: string | null;
    }>;
  });
